export const helpUrls = {
  contactEmail: 'mailto:ninjas@ninjaprotocol.io',
  discord: 'https://discord.gg/sQe88v9E',
  projectSerum: 'https://projectserum.com/',
  twitter: 'https://twitter.com/NinjaSolProto'
};
